import { config } from "../../../../../config";
import http from "../../../../../http";
import { GET_MILEAGE_BEGIN, GET_MILEAGE_SUCCESS } from "./type";
import { hasErrors } from "../../../error/actions";

export const getMileage = () => {
    return async dispatch => {
        try {
            dispatch(getBegin())
            const result = await http.get(config.api.COMMON.TITLE_REASON.GET_MILEAGES)
            dispatch(getSuccess(result))
        } catch (error) {
            dispatch(hasErrors(error))
        }
    }
}

const getBegin = () => {
    return dispatch => {
        dispatch({ type: GET_MILEAGE_BEGIN })
    }
}
const getSuccess = (items) => {
    return dispatch => {
        dispatch({ type: GET_MILEAGE_SUCCESS, payload: { items, loading: false } })
    }
}